module.exports = __webpack_public_path__ + "img/emptyimg.ae57296d.png";